var _path, _g, _path2, _path3, _path4, _path5, _path6, _rect, _g2, _rect2, _rect3, _path7, _rect4, _path8, _g3, _g4, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 361,
    viewBox: "0 0 380 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9824 62.293L229.419 19.9843L288.018 292.707L90.5814 335.016L31.9824 62.293Z",
    fill: "#E0E0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2256 66.0937L227.247 25.1574L283.877 288.764L92.8552 329.7L36.2256 66.0937Z",
    fill: "url(#paint0_linear)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4326 67.9727L226.115 27.9664L281.567 286.028L94.8846 326.034L39.4326 67.9727Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.6338 46.1172L175.534 26.4082L180.367 48.8852L88.467 68.5942L83.6338 46.1172Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.318 30.2678C112.716 22.9749 117.325 15.8208 124.61 14.2901C131.894 12.7594 139.08 17.4394 140.683 24.7322C142.285 32.0251 137.662 39.1792 130.391 40.7099C123.12 42.2406 115.921 37.5606 114.318 30.2678ZM120.855 32.1059C122.741 34.6796 126.032 35.8813 129.181 35.1466C131.225 34.6948 133 33.4649 134.114 31.7291C135.229 29.9933 135.59 27.8947 135.118 25.8976C134.427 22.8036 131.892 20.4261 128.702 19.8816C125.513 19.3371 122.304 20.7338 120.582 23.4158C118.861 26.0978 118.968 29.5321 120.855 32.1059Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7275 46L175.649 26.4987L180.273 48L89.3515 67.5013L84.7275 46Z",
    fill: "#6A69E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.292 30.726C113.786 23.7071 118.254 16.796 125.272 15.2895C128.643 14.566 132.163 15.2113 135.058 17.0835C137.953 18.9557 139.985 21.9013 140.708 25.2723C142.214 32.2914 137.745 39.2021 130.727 40.7081C123.708 42.214 116.798 37.745 115.292 30.726ZM121.824 32.2739C123.548 34.7715 126.606 35.9849 129.572 35.3482C133.622 34.4791 136.202 30.4913 135.333 26.4405C134.697 23.4734 132.337 21.1816 129.352 20.6339C126.368 20.0862 123.348 21.3905 121.7 23.9384C120.052 26.4864 120.101 29.7763 121.824 32.2739Z",
    fill: "#6A69E4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 54,
    width: 202,
    height: 279,
    fill: "#E0E0E0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122.13,
    y: 58.0547,
    width: 195.652,
    height: 269.727,
    fill: "url(#paint3_linear)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 61,
    width: 191,
    height: 264,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 49,
    width: 94,
    height: 23,
    fill: "url(#paint4_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207 40.5C207 33.0431 213.045 27 220.5 27C227.955 27 234 33.0431 234 40.5C234 47.9569 227.955 54 220.5 54C213.045 54 207 47.9569 207 40.5ZM212.998 43.6112C214.293 46.5152 217.258 48.3647 220.5 48.2895V48.2526C224.838 48.2018 228.317 44.7368 228.286 40.5C228.285 37.3328 226.321 34.4815 223.317 33.2874C220.314 32.0934 216.869 32.7944 214.604 35.0607C212.339 37.3269 211.704 40.7072 212.998 43.6112Z",
    fill: "url(#paint5_linear)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 49,
    width: 93,
    height: 22,
    fill: "#6A69E4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.99 35.025C211.002 30.1673 215.742 27 221 27C228.18 27 234 32.8202 234 39.9998C234 45.2577 230.833 49.9979 225.975 52.0101C221.117 54.0222 215.526 52.91 211.808 49.1921C208.09 45.4741 206.978 39.8827 208.99 35.025ZM213.507 39.9998C213.507 44.1399 216.86 47.4976 221 47.5027V47.4795C222.991 47.4819 224.901 46.6932 226.31 45.2869C227.719 43.8805 228.511 41.9719 228.512 39.9812C228.502 35.8411 225.14 32.4918 221 32.4969C216.86 32.502 213.507 35.8597 213.507 39.9998Z",
    fill: "#6A69E4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.63477,
    y: 340.023,
    width: 1.88,
    height: 10.665,
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9102 344.418V346.298H2.24516V344.418H12.9102Z",
    fill: "#47E6B1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.539,
    width: 1.79826,
    height: 10.665,
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.541 4.39062V6.27062L204.34 6.27062V4.39062L214.541 4.39062Z",
    fill: "#47E6B1"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.347 357.067C356.324 356.621 355.797 355.479 356.122 354.411C356.147 354.332 356.163 354.25 356.169 354.168C356.199 353.683 355.907 353.236 355.451 353.068C354.995 352.9 354.483 353.05 354.191 353.438C354.141 353.505 354.1 353.577 354.067 353.653C353.621 354.676 352.479 355.203 351.411 354.878C351.332 354.853 351.25 354.837 351.168 354.831C350.683 354.801 350.236 355.093 350.068 355.549C349.9 356.005 350.05 356.517 350.438 356.809C350.505 356.859 350.577 356.9 350.653 356.933C351.676 357.379 352.203 358.521 351.878 359.589C351.853 359.668 351.837 359.75 351.831 359.832C351.801 360.317 352.093 360.764 352.549 360.932C353.005 361.1 353.517 360.95 353.809 360.562C353.859 360.495 353.9 360.423 353.933 360.347C354.379 359.324 355.521 358.797 356.589 359.122C356.668 359.147 356.75 359.163 356.832 359.169C357.317 359.199 357.764 358.907 357.932 358.451C358.1 357.995 357.95 357.483 357.562 357.191C357.495 357.141 357.423 357.1 357.347 357.067Z",
    fill: "#4D8AF0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3472 262.067C62.3235 261.621 61.7965 260.479 62.1218 259.411C62.1472 259.332 62.1632 259.25 62.1695 259.168C62.1987 258.683 61.9068 258.236 61.4511 258.068C60.9953 257.9 60.4832 258.05 60.1907 258.438C60.1411 258.505 60.0995 258.577 60.0668 258.653C59.6211 259.676 58.4789 260.203 57.4109 259.878C57.332 259.853 57.2504 259.837 57.1677 259.831C56.6829 259.801 56.2361 260.093 56.0681 260.549C55.9 261.005 56.0504 261.517 56.4382 261.809C56.5046 261.859 56.5767 261.9 56.6528 261.933C57.6765 262.379 58.2035 263.521 57.8782 264.589C57.8528 264.668 57.8368 264.75 57.8305 264.832C57.8013 265.317 58.0932 265.764 58.5489 265.932C59.0047 266.1 59.5168 265.95 59.8093 265.562C59.8589 265.495 59.9005 265.423 59.9332 265.347C60.3789 264.324 61.5211 263.797 62.5891 264.122C62.668 264.147 62.7496 264.163 62.8323 264.169C63.3171 264.199 63.7639 263.907 63.9319 263.451C64.1 262.995 63.9496 262.483 63.5618 262.191C63.4954 262.141 63.4233 262.1 63.3472 262.067Z",
    fill: "#FDD835"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.347 32.0668C306.324 31.6211 305.797 30.4789 306.122 29.4109C306.147 29.332 306.163 29.2504 306.169 29.1677C306.199 28.6829 305.907 28.2361 305.451 28.0681C304.995 27.9 304.483 28.0504 304.191 28.4382C304.141 28.5046 304.1 28.5767 304.067 28.6528C303.621 29.6765 302.479 30.2035 301.411 29.8782C301.332 29.8528 301.25 29.8368 301.168 29.8305C300.683 29.8013 300.236 30.0932 300.068 30.5489C299.9 31.0047 300.05 31.5168 300.438 31.8093C300.505 31.8589 300.577 31.9005 300.653 31.9332C301.676 32.3789 302.203 33.5211 301.878 34.5891C301.853 34.668 301.837 34.7496 301.831 34.8323C301.801 35.3171 302.093 35.7639 302.549 35.9319C303.005 36.1 303.517 35.9496 303.809 35.5618C303.859 35.4954 303.9 35.4233 303.933 35.3472C304.379 34.3235 305.521 33.7965 306.589 34.1218C306.668 34.1472 306.75 34.1632 306.832 34.1695C307.317 34.1987 307.764 33.9068 307.932 33.4511C308.1 32.9953 307.95 32.4832 307.562 32.1907C307.495 32.1411 307.423 32.0995 307.347 32.0668Z",
    fill: "#FDD835"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.5 149C378.433 149 380 147.433 380 145.5C380 143.567 378.433 142 376.5 142C374.567 142 373 143.567 373 145.5C373 147.433 374.567 149 376.5 149Z",
    fill: "#F55F44"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.5 349C108.433 349 110 347.433 110 345.5C110 343.567 108.433 342 106.5 342C104.567 342 103 343.567 103 345.5C103 347.433 104.567 349 106.5 349Z",
    fill: "#F55F44"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.5 224C342.433 224 344 222.433 344 220.5C344 218.567 342.433 217 340.5 217C338.567 217 337 218.567 337 220.5C337 222.433 338.567 224 340.5 224Z",
    fill: "#F55F44"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5 48C42.433 48 44 46.433 44 44.5C44 42.567 42.433 41 40.5 41C38.567 41 37 42.567 37 44.5C37 46.433 38.567 48 40.5 48Z",
    fill: "#4D8AF0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 143C5.433 143 7 141.433 7 139.5C7 137.567 5.433 136 3.5 136C1.567 136 0 137.567 0 139.5C0 141.433 1.567 143 3.5 143Z",
    fill: "#47E6B1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 283.875,
    y1: 288.764,
    x2: 227.301,
    y2: 25.0959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 180.367,
    y1: 48.8852,
    x2: 175.542,
    y2: 26.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 143.615,
    y1: 37.8003,
    x2: 137.821,
    y2: 11.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 317.78,
    y1: 327.782,
    x2: 317.78,
    y2: 58.0547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 268,
    y1: 72,
    x2: 268,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 234,
    y1: 53.9769,
    x2: 234,
    y2: 26.9769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState2);
export default __webpack_public_path__ + "static/media/empty-state-2.04ca391b8b90a3806ad265e4161d3f6e.svg";
export { ForwardRef as ReactComponent };